module.exports = __webpack_public_path__ + "static/media/blog1.70e60a5e.jpg";